<template>
    <ui-modal title="Send remote invite" :close="close">
        <ui-form-section class="mt-6">
            <ui-select-searchable
                class="col-span-12"
                label="Email Address"
                v-model="form.recipient"
                :error="form.errors.get('email')"
                :create-option="email => ({ email })"
                option-label="name"
                :search="searchContact"
            >
                <template #option="{ name, email }">
                    <p v-if="email">{{ name }} &lt;{{ email }}&gt;</p>
                    <p v-else>{{ name }}</p>
                </template>
                <template #selected-option="{ name, email }">
                    <p v-if="name">{{ name }} &lt;{{ email }}&gt;</p>
                    <p v-else>{{ email }}</p>
                </template>
            </ui-select-searchable>
            <ui-select-searchable
                class="col-span-12"
                label="CC Email Addresses"
                v-model="form.cc_recipients"
                :error="form.errors.get('cc')"
                :create-option="email => ({ email })"
                option-label="name"
                :search="searchContact"
                multiple
            >
                <template #option="{ name, email }">
                    <p v-if="email">{{ name }} &lt;{{ email }}&gt;</p>
                    <p v-else>{{ name }}</p>
                </template>
                <template #selected-option="{ name, email }">
                    <p v-if="name">{{ name }} &lt;{{ email }}&gt;</p>
                    <p v-else>{{ email }}</p>
                </template>
            </ui-select-searchable>
            <ui-input label="Email Subject" name="subject" :error="form.errors.get('subject')" v-model="form.subject"></ui-input>
            <ui-textarea autoresize label="Email Body" name="body" :error="form.errors.get('body')" v-model="form.body" :info="`Note, %WEBLINK% will be replace with a link the user can click on to view the ${type}.`"></ui-textarea>
        </ui-form-section>
        <template #footer-primary>
            <ui-button-new primary class="w-full" :loading="form.busy" @click="form.submit()">Send</ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import { capitalize } from '@utils'
import { RemoteInvite, Contact } from '@models'

export default {
    props: {
        close: Function,
        type: String,
        identifier: String|Number,
        initialData: Object,
        onCreated: {
            type: Function,
            default: () => {},
        }
    },
    data () {
        const initialData = {
            recipient: { name: '', email: '' },
            email: '',
            cc_recipients: [],
            cc: [],
            subject: `${capitalize(this.type)} #${this.identifier}`,
            body: `Please click on the following link to view the ${this.type}.\n\n%WEBLINK%\nThis link will be valid for 30 days.`,
            ...this.initialData,
        }

        return {
            form: new Form(initialData, async form => {
                form.type = this.type
                form.typeId = this.identifier
                form.email = form.recipient.email
                form.cc = form.cc_recipients.map(recipient => recipient.email)

                try {
                    const newRemoteInvites = await RemoteInvite.create(form)
                    this.onCreated(newRemoteInvites, this.close)
                } catch (error) {
                    this.close()
                }
            })
        }
    },
    methods: {
        async searchContact (query) {
            return await Contact.search(query)
        },
    },
}
</script>
